import React, { useState, useEffect } from 'react';
import RatingView from '../../Components/RatingView';
import moment from 'moment';
import { ReviewType } from '../../Components/Types';
import styled, { css } from "styled-components";
import { ArrowLeftCircleFill, ArrowRightCircleFill } from 'react-bootstrap-icons';
import { ReviewsAPI } from 'API/ReviewAPI';
import Loader from 'Components/Loader';
import { maxNoReviewsVisible } from 'Components/Constants';
import { RowContainer } from 'Components/PageComponents';
import Button from 'Components/Button';
import { useMediaQuery } from 'react-responsive';

export type ReviewBlockProps = {
    $extended: boolean;
}

const iconStyle = css`
    color:var(--main-teal-color);
    font-size:2rem;
    cursor:pointer;
    transition: 0.3s;
        :hover {
            font-size:2.5rem;
            transition: 0.3s;
`;

const ArrowLeft = styled(ArrowLeftCircleFill)`
    ${iconStyle}
`;
const ArrowRight = styled(ArrowRightCircleFill)`
    ${iconStyle}
`;

const ReviewBody = styled.div<ReviewBlockProps>`
    overflow: ${props => props.$extended ? "visible" : "hidden"};
    ${props => !props.$extended && "height: 7em"};
    margin-bottom: 40px;
`;

const ReviewBlock = styled.div<ReviewBlockProps>`
    position: relative;
    background: var(--main-light-grey-color);
    width: ${props => props.$extended ? "22em" : "16em"};
    ${props => !props.$extended && "height: 18em;"}
    transition: 0.3s;
    margin: 1em;
    padding: 1em;
    border-radius: 3px;
`;


function ReviewCarousel() {

    const [allReviews, setAllReviews] = useState<ReviewType[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const [visibleReviews, setVisibleReviews] = useState<ReviewType[]>([]);
    const maxReviewTextLength = 182;
    
    const desktopView = useMediaQuery({
        query: '(min-width: 1050px)'
    });

    const mobileView = useMediaQuery({
        query: '(max-width: 540px)'
    })

    var reviewsShown = desktopView ? maxNoReviewsVisible : 2;
    reviewsShown = mobileView ? 1 : reviewsShown;

    useEffect(() => {
        setLoading(true);
        const getReviews = async() => {
            const response = await ReviewsAPI.get();
            setAllReviews(response);
            setVisibleReviews(response);
            
        }
        getReviews();
        setLoading(false);
    },[]);


    const toggleReviews = (forward:boolean) => {
        const newVisibleReviews = [...visibleReviews];
        const reviewsList = allReviews;

        if (forward) {
            const lastReviewId = visibleReviews.slice(-1)[0].review_id;
            const lastReview = reviewsList.findIndex(review => review.review_id == lastReviewId);
            const newReview = reviewsList[lastReview + 1];
            if (newReview) {
                newVisibleReviews.shift();
                newVisibleReviews.push(newReview);
            }
            else {
                const firstReview = reviewsList[0];
                newVisibleReviews.shift();
                newVisibleReviews.push(firstReview);
            }
        }
        else {
            const firstReviewId = visibleReviews[0].review_id;
            const firstReview = reviewsList.findIndex(review => review.review_id == firstReviewId);
            const newReview = reviewsList[firstReview - 1];
            if (newReview) {
                newVisibleReviews.pop();
                newVisibleReviews.unshift(newReview);
            }
            else {
                const lastReview = reviewsList.slice(-1)[0];
                newVisibleReviews.pop();
                newVisibleReviews.unshift(lastReview);
            }
        }
        setVisibleReviews(newVisibleReviews)
    }

    const extendReview = (idx: number) => {
        const reviewList = [...visibleReviews];
        reviewList[idx].extended = !reviewList[idx].extended;
        setVisibleReviews(reviewList);
    }


    return (
        <RowContainer>
            {loading ?
            <Loader/> :
            <>
                {visibleReviews.length >= reviewsShown &&
                <RowContainer>
                    <ArrowLeft onClick={() => toggleReviews(false)} />
                </RowContainer>
                }
                {visibleReviews.slice(0, reviewsShown).map((review: ReviewType, i:number) => {
                    return (
                        <ReviewBlock key={review.review_id} $extended={review.extended ?? false}>
                            <RatingView rating={review.rating} />
                            <h4 style={{fontFamily: "Lato-Black", fontSize: "1rem"}}>{review.name}</h4>
                            <p style={{fontSize:"0.8rem"}}>{moment(review.date).format("MMMM YYYY")}</p>
                            <ReviewBody $extended={review.extended ?? false}>
                                <p style={{fontSize:"0.8rem"}}>{review.text}</p>
                            </ReviewBody>
                            <div style={{position:"absolute", left:"10px", bottom:"10px"}}>
                            {review.text.length > maxReviewTextLength && 
                                <Button 
                                    type={"button"} 
                                    colour={"dark"} 
                                    text={review.extended ? "Read Less" : "Read More"} 
                                    css={{fontFamily: "Lato-Bold" }}
                                    onClick={() => extendReview(i)}
                                />
                            }
                            </div>
                        </ReviewBlock>
                    );
                })}
                {visibleReviews.length >= reviewsShown &&
                    <RowContainer>
                        <ArrowRight onClick={() => toggleReviews(true)} />
                    </RowContainer>
                }
            </>
            }
        </RowContainer>
    );
}
export default ReviewCarousel;
